module.exports = __webpack_public_path__ + "img/回写配置一键导入.1ad44cce.svg";